// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".area-select-root[data-v-63c221ee] {\n  display: flex;\n  align-items: center;\n}\n.area-select-root[data-v-63c221ee] .el-select {\n  flex: 1;\n}\n.area-select-root[data-v-63c221ee] .el-select + .el-select {\n  margin-left: 8px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
